export const complianceFeatureKey = 'compliance';
